export const complianceFeatureKey = 'compliance';
